import { jsx as o, jsxs as m, Fragment as b } from "react/jsx-runtime";
import { useState as _ } from "react";
import { useBreakpoint as k, NextgenImage as B, LoaderType as p, BrightcovePlayer as P } from "@nextgen-web-framework/all";
import { ConfigService as w } from "@nextgen-web-framework/core";
import { Video as l } from "./types/propsTypes.js";
import '../../assets/VideoSection.css';const N = "#ffffff", I = "#396e75", T = "#e5fdff", O = "#546223", G = "#f0fae5", R = "#a65523", E = "#fff1e8", S = "#7f3e3e", W = "#ffe2e2", Y = "#62625a", x = "#f8f8e7", A = "#38539a", D = "#707070", U = "#c8f8d1", K = "#87c9c8", $ = "#5291b1", j = "rgba(82, 145, 177, 0.1019607843)", F = "#445685", H = "#181d61", L = "rgba(24, 29, 97, 0.1019607843)", X = "#5969d6", q = "#ea999d", J = "#b6577e", M = "rgba(182, 87, 126, 0.1019607843)", Q = "#7e3e80", Z = "#1e247f", ee = "rgba(30, 36, 127, 0.1019607843)", ae = "#da7600", oe = "#107f47", te = "#d91734", ie = "_html_r71f0_38", t = {
  amwayWhite: N,
  darkBlue: I,
  lightBlue: T,
  darkGreen: O,
  lightGreen: G,
  darkOrange: R,
  lightOrange: E,
  darkRed: S,
  lightRed: W,
  darkYellow: Y,
  lightYellow: x,
  darkPurple: A,
  darkGrayOnWhite: D,
  dataVizColor1: U,
  dataVizColor2: K,
  dataVizColor3: $,
  dataVizColor3Background: j,
  dataVizColor4: F,
  dataVizColor5: H,
  dataVizColor5Background: L,
  dataVizColor6: X,
  dataVizColor7: q,
  dataVizColor8: J,
  dataVizColor8Background: M,
  dataVizColor9: Q,
  dataVizColor10: Z,
  dataVizColor10Background: ee,
  dataVizAlertOrange: ae,
  dataVizSuccessGreen: oe,
  dataVizWarningRed: te,
  "no-visible": "_no-visible_r71f0_34",
  html: ie,
  "video-section-container": "_video-section-container_r71f0_72",
  "video-player-container": "_video-player-container_r71f0_80",
  "video-player": "_video-player_r71f0_80",
  "video-section-thumbnail-container": "_video-section-thumbnail-container_r71f0_92",
  "video-section-thumbnail-image": "_video-section-thumbnail-image_r71f0_102",
  "video-section-thumbnail-play-button": "_video-section-thumbnail-play-button_r71f0_107"
}, se = (e) => {
  var s;
  const d = w.getConfigs(), [n, y] = _(!1), f = k(), i = (s = e == null ? void 0 : e.images) == null ? void 0 : s.find((a) => {
    var r;
    return (r = a == null ? void 0 : a.viewport) == null ? void 0 : r.includes(f);
  }), c = () => {
    y(!0);
  }, v = (a) => {
    (a.key === "Enter" || a.key === " ") && (a.preventDefault(), c());
  }, h = () => {
    const a = `${e.videoUrl}${n || e.autoPlay ? "?autoplay=1&mute=1&playsinline=1" : ""}`;
    return /* @__PURE__ */ o(
      "iframe",
      {
        className: t["video-player"],
        src: a,
        title: e.title,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: !0
      }
    );
  }, C = () => /* @__PURE__ */ m("video", { className: t["video-player"], controls: !0, autoPlay: n || e.autoPlay, children: [
    /* @__PURE__ */ o("track", { kind: "captions" }),
    /* @__PURE__ */ o("source", { src: e.videoUrl })
  ] }), V = () => {
    var a, r, u, g;
    return /* @__PURE__ */ o("div", { className: t["video-player"], children: /* @__PURE__ */ o(
      P,
      {
        isPlayerResponsive: !1,
        containerClassName: `${t["modal-brightCoveContainer"]}`,
        accountId: ((a = e.brightcove) == null ? void 0 : a.accountId) ?? d.NEXT_BRIGHT_COVE_ACC_ID,
        playerId: ((r = e.brightcove) == null ? void 0 : r.playerId) ?? d.NEXT_BRIGHT_COVE_PLAYER_ID,
        videoId: ((u = e.brightcove) == null ? void 0 : u.videoId) ?? "",
        poster: (g = e.brightcove) == null ? void 0 : g.poster,
        autoplay: n || e.autoPlay,
        muted: !0
      }
    ) });
  }, z = () => {
    switch (e.videoType) {
      case l.brightcove:
        return V();
      case l.youtube:
        return h();
      case l.upload:
        return C();
      default:
        return /* @__PURE__ */ o(b, {});
    }
  };
  return /* @__PURE__ */ o("div", { className: t["video-section-container"], "data-testid": "video-section-testid", "data-pod-name": "commerce", children: !n && (i != null && i.url) && !e.autoPlay ? /* @__PURE__ */ m(
    "button",
    {
      type: "button",
      "data-testid": "video-section-thumbnail-container-testId",
      "data-pod-name": "commerce",
      className: t["video-section-thumbnail-container"],
      onClick: c,
      onKeyDown: v,
      "aria-label": "Play video thumbnail",
      children: [
        /* @__PURE__ */ o(
          B,
          {
            className: t["video-section-thumbnail-image"],
            src: i.url,
            alt: i.altText,
            loaderType: p.CONTENTSTACK
          }
        ),
        /* @__PURE__ */ o("span", { className: t["video-section-thumbnail-play-button"], children: "▶" })
      ]
    },
    i.url
  ) : /* @__PURE__ */ o("div", { className: t["video-player-container"], children: z() }) });
};
export {
  se as default
};
//# sourceMappingURL=VideoSection.js.map
